<template>
	<div class='main-mybody' id='ediof'>
		<a-row>
				<a-col :span='24'>
					<div class='look_g'><div></div>使用者名稱與密碼</div>
					<a-row><a-col :span='4'>使用者名稱</a-col><a-col :span='7'>{{form.name}}</a-col></a-row>
					<a-row><a-col :span='4'>舊密碼</a-col><a-col :span='7'>********</a-col></a-row>
					<a-row><a-col :span='4'>輸入新密碼</a-col><a-col :span='7'>
					<a-input-password placeholder=" " v-model='form.password' @blur='handler("pass")' :maxLength='8'/></a-col>
					<a-col :span='4'>
						 <a-popover placement="right" :destroyTooltipOnHide="true" trigger="hover"
						 	:overlayStyle="{width:'calc(17rem + 32px)'}"
						 	:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
						        <template slot="content" style="backgroundColor:#e5e5e5">
						          <span style="color: #000000;">
									  密礪有效字數為8位，密碼須包含數字、英文（大寫）、英文（小寫），但不能包含三個或以上連續相同的字符。為描保密碼的安全，新密碼不接受與舊密碼或登入名稱相同。
								  </span>
						        </template>
						        <a-icon type="question-circle" style='font-size: 1rem;margin-left: .5rem;margin-top: .25rem;color: #666;'/>
						      </a-popover>
					</a-col>
					</a-row>
					<a-row><a-col :span='4'>確認新密碼</a-col><a-col :span='7'>  
					<a-input-password placeholder=" " v-model='form.newpassword'  :maxLength='8' @blur='handler("pass")'/></a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='24'>
					<div class='look_g'><div></div>安全性資訊問題</div>
					<a-row><a-col :span='4'>安全性問題1</a-col><a-col :span='7'>
					<a-select v-model='form.securityquestion1' style="width: 100%" >
					     <a-select-option :value="item" v-for='(item,ind) in form.securityQuestion1List' 
						 :key='ind + "001"' :disabled='form.securityquestion2==item||form.securityquestion3==item'>{{item}}
					     </a-select-option>
					   </a-select></a-col></a-row>
					<a-row v-if='foms.t1'><a-col :span='4'>舊答案</a-col><a-col :span='7'>********</a-col></a-row>
					<a-row><a-col :span='4'>新答案1</a-col><a-col :span='7'>
						<a-input-password placeholder=" " v-model='form.anwser1'  @blur='handler("an1")'/></a-col></a-row>
					<a-row><a-col :span='4'>確認新答案1</a-col><a-col :span='7'>  
						<a-input-password placeholder=" " v-model='form.newanwser1' @blur='handler("an1")'/>
					</a-col></a-row>
					<a-row><a-col :span='4'>安全性問題2</a-col><a-col :span='7'>
					<a-select v-model='form.securityquestion2' style="width: 100%" >
						     <a-select-option :value="item" v-for='(item,ind) in form.securityQuestion2List' :key='ind + "002"'
							  :disabled='form.securityquestion1==item||form.securityquestion3==item'>
						      {{item}}
						     </a-select-option>
						   </a-select></a-col></a-row>
					<a-row v-if='foms.t2'><a-col :span='4'>舊答案</a-col><a-col :span='7'>********</a-col></a-row>
					<a-row><a-col :span='4'>新答案2</a-col><a-col :span='7'>
						<a-input-password placeholder=" " v-model='form.anwser2' @blur='handler("an2")'/></a-col></a-row>
					<a-row><a-col :span='4'>確認新答案2</a-col><a-col :span='7'>  
						<a-input-password placeholder=" " v-model='form.newanwser2'  @blur='handler("an2")'/>
					</a-col></a-row>
					<a-row><a-col :span='4'>安全性問題3</a-col><a-col :span='7'>
					<a-select v-model='form.securityquestion3' style="width: 100%" >
						     <a-select-option :value="item" v-for='(item,ind) in form.securityQuestion3List' :key='ind + "003"'
							  :disabled='form.securityquestion2==item||form.securityquestion1==item'>
						      {{item}}
						     </a-select-option>
						   </a-select></a-col></a-row>
					<a-row v-if='foms.t3'><a-col :span='4'>舊答案</a-col><a-col :span='7'>******</a-col></a-row>
					<a-row><a-col :span='4'>新答案3</a-col><a-col :span='7'>
						<a-input-password placeholder=" " v-model='form.anwser3' @blur='handler("an3")'/></a-col></a-row>
					<a-row><a-col :span='4'>確認新答案3</a-col><a-col :span='7'>  
					<div style="display: flex;justify-content: space-between;">
						<a-input-password placeholder=" " v-model='form.newanwser3' @blur='handler("an3")'/>
					</div>
					</a-col></a-row>
				</a-col>
				
		</a-row>
	</div>
</template>

<script>
	function getBase64(img, callback) {
		const reader = new FileReader();
		reader.addEventListener('load', () => callback(reader.result));
		reader.readAsDataURL(img);
	}
	export default {
		props:['lookfrom'],
		data(){
			return {
					form:{},
					foms:{
						t1:'',
						t2:'',
						t3:''
					}
			}
		},
		// watch:{
		// 	lookfrom:{
		// 		immediate:true,
		// 		deep:true,
		// 		handler(ev){
		// 			if(ev){
						
		// 			}
		// 		}
		// 	}
		// },
		mounted() {
			let obj = JSON.parse(JSON.stringify(this.lookfrom))
			if(obj.securityquestion1){
				this.foms.t1 = obj.securityquestion1
			}
			if(obj.securityquestion2){
				this.foms.t2 = obj.securityquestion2
			}
			if(!obj.securityquestion3){
				
				this.foms.t3 = obj.securityquestion3
			}
				if(obj.securityQuestion1List){
					obj.securityQuestion1List.map((ev,ind)=>{
					if(ind == 0){
						if(!obj.securityquestion1){
								this.$set(obj,'securityquestion1',ev)
						}
					}
					if(ind == 1){
						if(!obj.securityquestion2){
								this.$set(obj,'securityquestion2',ev)
						}
					}
					if(ind == 2){
						if(!obj.securityquestion3){
								this.$set(obj,'securityquestion3',ev)
						}
					}
				})
				}
				
			
			this.form = obj
			// if(!this.form.securityquestion1){
			// 	if(this.form.securityQuestion1List.length){
			// 		console.log(this.form.securityQuestion1List[0])
			// 		this.form.securityquestion1 = this.form.securityquestion1List[0]
			// 	}
			// }else{
			// 	this.foms.t1 = this.form.securityquestion1
			// }
			// if(!this.form.securityquestion2){
			// 	if(this.form.securityquestion2List){
			// 		console.log(this.form.securityquestion2List[1])
			// 		this.form.securityquestion2 = this.form.securityquestion2List[1]
			// 	}
			// }else{
			// 	this.foms.t2 = this.form.securityquestion2
			// }
			// if(!this.form.securityquestion3){
			// 	if(this.form.securityquestion3List){
			// 		this.form.securityquestion3 = this.form.securityquestion3List[2]
			// 	}
			// }else{
			// 	this.foms.t3 = this.form.securityquestion3
			// }
		},
		methods:{
			beforeUpload(file){
				// 
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				if (!isJpgOrPng) {
					this.$message.error('You can only upload JPG file!');
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('Image must smaller than 2MB!');
				}
				return isJpgOrPng && isLt2M;
			},
			handleChange(info){
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				// if (info.file.status === 'done') {
				// Get this url from response in real world.
				getBase64(info.file.originFileObj, imageUrl => {
					this.form.homeaddress_pic = imageUrl;
					this.loading = false;
				});
			},
			numfn(val) {
				if(this.form[val]){
					if (isNaN(this.form[val])) {
						this.form[val] = ''
					} else {
						this.form[val] = parseInt(this.form[val])
					}
				}
			},
			passfn(val) {
				var reg = /^(?![^a-z]+$)(?![^A-Z]+$)(?!\D+$).{8,8}$/;
				var re = /(\w)*(\w)\2{2}(\w)*/g;
				if (!reg.test(val)) {
					this.$message.warning('輸入的新密碼至少包含一個大寫字母，小寫字母和數字，長度在8')
					return true
				}
				if (re.test(val)) {
					this.$message.warning('不能包含三個或以上連續相同的字符')
					return true
				}
			},
			handler(val){
				if(val == 'pass'){
					if(this.form.newpassword||this.form.password){
					if(this.passfn(this.form.password)){
						return
					}}
					console.log('12')
					if(this.form.newpassword&&this.form.password){
						if(this.form.newpassword!==this.form.password){
							this.$message.warning('密碼輸入不一致')
						}else{
						if(this.passfn(this.form.password)){
							return
						}
					}
					}
				}else if(val == 'an1'){
					if(this.form.anwser1&&this.form.newanwser1){
					if(this.form.anwser1!==this.form.newanwser1){
						this.$message.warning('新答案1輸入不一致')
					}}
				}else if(val == 'an2'){
					if(this.form.anwser2&&this.form.newanwser2){
					if(this.form.anwser2!==this.form.newanwser2){
						this.$message.warning('新答案2輸入不一致')
					}}
				}else if(val == 'an3'){
					if(this.form.anwser3&&this.form.newanwser3){
					if(this.form.anwser3!==this.form.newanwser3){
						this.$message.warning('新答案3輸入不一致')
					}}
				}
			}
		}
	}
</script>

<style lang='scss'>

</style>
